export const AUCTION_OFFLINE = 'Auction offline';
export const AUCTION_ONLINE = 'Auction online';
export const EDIT_DONOR = 'Edit Donor';
export const ADD_DONOR = 'Add Donor';
export const DONORS = 'Donors';
